export const WHITE = 0xffffff;
export const BLACK = 0x000000;

export const TIMELINE_MARGIN_GRAY = 0x383a3a;

export const SCROLLBAR_FOREGROUND = 0x707070;
export const MOUSE_OVER_GRAY = 0x999999;
export const MOUSE_DOWN_GRAY = 0x606060;
